import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/i18n/LangContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Executive from "@/pages/Executive";
import Sales from "@/pages/Sales";
import Finance from "@/pages/Finance";
import DataQuality from "@/pages/DataQuality";
import Milestone from "@/pages/Milestone";
import CalcCentre from "@/pages/CalcCentre";
import Schemes from "@/pages/Schemes";
import SchemeBuilder from "@/pages/SchemeBuilder";
import MasterData from "@/pages/MasterData";
import Exceptions from "@/pages/Exceptions";
import Approvals from "@/pages/Approvals";
import Settlements from "@/pages/Settlements";
import Audit from "@/pages/Audit";
import Acceptance from "@/pages/Acceptance";
import WorkflowBuilder from "@/pages/WorkflowBuilder";
import UploadStudio from "@/pages/UploadStudio";
import Reports from "@/pages/Reports";
import DealerPortal from "@/pages/DealerPortal";

function AuthLoading() {
  return (
    <div className="min-h-screen flex items-center justify-center adani-navy-gradient">
      <div className="text-white/80 animate-pulse font-heading">Loading SchemeCentral…</div>
    </div>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <AuthLoading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "Dealer") return <Navigate to="/portal" replace />;
  return <Layout>{children}</Layout>;
}

function DealerRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <AuthLoading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "Dealer") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LangProvider>
          <Toaster position="top-right" richColors closeButton />
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/portal" element={<DealerRoute><DealerPortal /></DealerRoute>} />
              <Route path="/" element={<Protected><Executive /></Protected>} />
              <Route path="/sales" element={<Protected><Sales /></Protected>} />
              <Route path="/finance" element={<Protected><Finance /></Protected>} />
              <Route path="/data-quality" element={<Protected><DataQuality /></Protected>} />
              <Route path="/milestone" element={<Protected><Milestone /></Protected>} />
              <Route path="/reports" element={<Protected><Reports /></Protected>} />
              <Route path="/calc-centre" element={<Protected><CalcCentre /></Protected>} />
              <Route path="/schemes" element={<Protected><Schemes /></Protected>} />
              <Route path="/schemes/new" element={<Protected><SchemeBuilder /></Protected>} />
              <Route path="/schemes/:id/edit" element={<Protected><SchemeBuilder /></Protected>} />
              <Route path="/master-data" element={<Protected><MasterData /></Protected>} />
              <Route path="/exceptions" element={<Protected><Exceptions /></Protected>} />
              <Route path="/workflows" element={<Protected><WorkflowBuilder /></Protected>} />
              <Route path="/upload-studio" element={<Protected><UploadStudio /></Protected>} />
              <Route path="/approvals" element={<Protected><Approvals /></Protected>} />
              <Route path="/settlements" element={<Protected><Settlements /></Protected>} />
              <Route path="/audit" element={<Protected><Audit /></Protected>} />
              <Route path="/acceptance-tests" element={<Protected><Acceptance /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </LangProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
